<template>
  <div>
    <b-table-name v-if="header" :value="header" />
    <Spinner :isLoading="isLoading">
      <div class="table-wrapper">
        <table class="uk-table uk-table-middle uk-table-divider uk-margin-remove-bottom">
          <thead>
            <tr>
              <b-table-header
                v-for="(header, iter) in headers"
                :key="iter"
                :clear-filter="clearFilter"
                :header="header"
                @filtered="filter"
                @clearFilter="clear"
              />
            </tr>
          </thead>
          <tbody v-if="tableContent.length === 0">
            <tr>
              <td :colspan="headers.length" style="align-content: center; text-align: center">
                <div class="table-body">
                  Записи по данным параметрам отсутствуют. Пожалуйста, проверьте введенные
                  параметры.
                </div>
              </td>
            </tr>
          </tbody>
          <tbody is="transition-group" v-else name="list">
            <tr
              v-for="(row, iterRow) in tableContent"
              :key="`table_row_${row.id}_${iterRow}`"
              class="fruit-list-item"
            >
              <td v-for="(column, iterCol) in columns" :key="`table_col_${iterCol}`">
                <div v-if="column.type === 'occupantStatus'" style="display: flex">
                  <span
                    :uk-icon="`icon: ${row[column.name] ? 'check' : 'close'}; ratio: 0.8`"
                    :style="`color: ${row[column.name] ? '#0FB269' : '#E31E24'}; flex: 0 0 auto`"
                  ></span>
                  <span
                    class="uk-margin-small-left"
                    v-text="occupantStatusAsString(row[column.name])"
                  ></span>
                </div>
                <span v-if="column.type === 'status'">
                  {{ statusAsString(row[column.name]) }}
                </span>
                <span v-if="column.type === 'residentialStatus'">
                  {{ residentialStatusAsString(row[column.name]) }}
                </span>
                <span v-if="column.type === 'applicationStatus'">
                  {{ applicationStatusAsString(row[column.name]) }}
                </span>
                <span v-if="column.type === Date || column.type === Number"
                  >{{
                    row[column.name] != null
                      ? new column.type(row[column.name]).toLocaleString()
                      : '-'
                  }}
                </span>
                <span v-if="column.type === String"
                  >{{
                    row[column.name] !== '' && row[column.name] !== null ? row[column.name] : '-'
                  }}
                </span>
                <div v-if="column.type === 'UnitedString' && column.unitedName !== 'communityName'">
                  <p class="first-column">
                    {{
                      row[column.name] !== '' && row[column.name] !== null ? row[column.name] : '-'
                    }}
                  </p>
                  <p>
                    {{
                      row[column.unitedName] !== '' && row[column.unitedName] !== null
                        ? row[column.unitedName]
                        : '-'
                    }}
                  </p>
                </div>
                <div v-if="column.type === 'UnitedString' && column.unitedName === 'communityName'">
                  <p class="first-column">
                    {{
                      row[column.name] !== '' && row[column.name] !== null ? row[column.name] : '-'
                    }}
                  </p>
                  <p>
                    {{
                      row[column.unitedName] !== '' && row[column.unitedName] !== null
                        ? '( есть TC в системе )'
                        : '( нету TC в системе )'
                    }}
                  </p>
                </div>
                <span v-if="column.type === 'ownershipType'"
                  >{{ row[column.name] !== '' ? ownershipTypeAsString(row[column.name]) : '-' }}
                </span>
                <span v-if="column.type === 'votingType'"
                  >{{
                    row[column.name] !== '' && row[column.name] !== null
                      ? answerTypeAsString(row[column.name])
                      : '-'
                  }}
                </span>
                <span v-if="column.type === 'acquainted'"
                  >{{ row[column.name] !== '' ? consentStatusAsString(row[column.name]) : '-' }}
                </span>
                <span
                  v-if="
                    column.type === 'more' &&
                      !column.modalLink &&
                      (typeof column.isShow === 'undefined' ||
                        (typeof column.isShow !== 'undefined' && column.isShow === true))
                  "
                  :uk-icon="
                    `icon: ${column.icon ? column.icon : 'chevron-right'}; ratio: ${
                      column.ratio ? column.ratio : 1.4
                    }`
                  "
                  class="table-details"
                  @click.once="
                    showMore(row['id'], column.url, iterRow)
                    $emit('setPayload', {occupantId: row.occupantId, name: row.fullName})
                  "
                ></span>
                <span v-if="column.type === 'date'"
                  >{{
                    row[column.name] !== '' && row[column.name] !== null
                      ? $moment(new Date(row[column.name]).toISOString()).format('YYYY-MM-DD')
                      : '-'
                  }}
                </span>
                <span
                  v-if="column.type === 'more' && column.modalLink"
                  :uk-icon="
                    `icon: ${column.icon ? column.icon : 'chevron-right'}; ratio: ${
                      column.ratio ? column.ratio : 1.4
                    }`
                  "
                  class="table-details"
                  @click="
                    showModal(column.modalLink, row)
                    $emit('setPayload', {occupantId: row.occupantId, name: row.fullName})
                  "
                ></span>
                <span v-if="column.type === 'dateRange'"
                  >{{
                    row[column.name.start] != null
                      ? new Date(row[column.name.start]).toLocaleDateString() +
                        ' - ' +
                        new Date(row[column.name.end]).toLocaleDateString()
                      : '-'
                  }}
                </span>
                <span
                  v-if="column.type === 'download'"
                  :uk-icon="`icon: ${column.icon ? column.icon : 'download'}; ratio: 1.3`"
                  class="table-details"
                  @click="handlerDownload(row['id'])"
                ></span>
                <b-table-address
                  v-if="column.type === 'address'"
                  :address-id="row[column.name]"
                ></b-table-address>
                <b-table-street
                  v-if="column.type === 'street'"
                  :street-id="row[column.name]"
                ></b-table-street>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="page.last != null && !page.last && tableContent.length !== 0"
        class="uk-text-center"
        @click="more"
      >
        <div class="table-more">
          <span>Показать еще</span>
          <span uk-icon="icon: chevron-down; ratio: 1"></span>
        </div>
      </div>
      <span ref="scrollEvent" class="scroll__event-block" />
    </Spinner>
  </div>
</template>

<script>
import BTableName from '@/components/table/b-table-name'
import BTableHeader from '@/components/table/b-table-header'
import {ownershipTypeAsString} from '@/views/variables/ownership_type'
import {consentStatusAsString} from '@/views/variables/consent_status'
import {answerTypeAsString} from '@/views/variables/answer_type'
import {occupantStatusAsString} from '@/views/variables/occupant_status'
import {statusAsString} from '@/views/variables/meeting_status'
import {residentialStatusAsString} from '@/views/variables/residential_status'
import {applicationStatusAsString} from '@/views/variables/application_status'
import BTableAddress from '@/components/table/b-table-address'
import BTableStreet from '@/components/table/b-table-street'
import {fileDownload} from '@/common/utils/file-download'
import {showSuccess} from '@/common/utils/notification'
import config from '@/config'

import {mapActions} from 'vuex'

export default {
  name: 'b-table',
  components: {BTableStreet, BTableAddress, BTableHeader, BTableName},
  props: {
    header: {
      type: String
    },
    headers: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    uri: {
      type: String,
      required: true
    },
    sort: {
      type: String,
      required: false,
      default: null
    },
    rowSize: {
      type: Number,
      required: false,
      default: config.TABLE_ROW_COUNT
    },
    content: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    page: {},
    tableContent: [],
    filters: [],
    params: {
      page: 0,
      size: config.TABLE_ROW_COUNT,
      sort: 'id,desc',
      filter: null
    },
    clearFilter: false,
    isLoading: false
  }),
  methods: {
    ...mapActions({
      downloadReport: 'finance/DOWNLOAD_FINANCIAL_REPORT',
      getListItems: 'GET_LIST'
    }),
    ownershipTypeAsString: ownershipTypeAsString,
    occupantStatusAsString: occupantStatusAsString,
    consentStatusAsString: consentStatusAsString,
    statusAsString: statusAsString,
    answerTypeAsString: answerTypeAsString,
    residentialStatusAsString: residentialStatusAsString,
    applicationStatusAsString: applicationStatusAsString,
    showMore(id, url, iterRow) {
      let pageCount = Math.floor(iterRow / config.TABLE_ROW_COUNT)
      if (url) {
        this.$router.push({path: `${url}/${id}`, query: {page: this.params.page}})
      } else {
        this.$router.push({
          path: this.$router.currentRoute.path + '/' + id,
          query: {page: pageCount}
        })
      }
    },
    showModal(nameOfModal, data) {
      this.$modal.show(nameOfModal, {data: data})
    },
    handlerDownload(id) {
      this.downloadReport(id)
        .then(resp => {
          fileDownload(resp)
          showSuccess('Выгрузка документа успешно завершена')
        })
        .catch(err => {
          console.log(err)
        })
    },
    filter(val) {
      val.forEach(it => this.configureFilter(it))
      this.params.page = 0
      this.updateData()
    },
    configureFilter(val) {
      if (this.filters.length === 0) {
        this.filters.push(val)
      } else {
        let current = this.filters.find(it => it.name === val.name)
        if (current === undefined) {
          this.filters.push(val)
        } else {
          current.value = val.value
        }
      }

      this.params.filter = null
      let filteredFilters = this.filters.filter(el => el.value != '')

      filteredFilters.forEach(it => {
        if (this.params.filter == null) {
          this.params.filter = it.name + it.operator + it.value
        } else {
          this.params.filter += ',' + it.name + it.operator + it.value
        }
      })
    },
    clear() {
      this.params.filter = null
      this.clearFilter = !this.clearFilter
      this.filters = []
      this.updateData()
      this.$emit('clearRangeDate')
    },
    more() {
      if (this.page.last) {
        return
      }
      this.params.page += 1
      this.getList(false)
    },
    getList(isNew) {
      this.isLoading = true
      if (this.sort != null) {
        this.params.sort = this.sort
      }
      if (this.uri) {
        const request = {uri: this.uri, params: this.params}
        this.getListItems(request)
          .then(resp => {
            this.page = resp
            if (isNew) {
              this.tableContent = resp.content
            } else {
              resp.content.forEach(it => this.tableContent.push(it))
            }
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false
            this.tableContent = []
          })
      }
    },
    updateData() {
      this.params.page = 0
      this.getList(true)
    },
    scrollToElement() {
      this.$refs.scrollEvent.scrollIntoView({behavior: 'smooth', block: 'end'})
    }
  },
  mounted() {
    if (this.rowSize > config.TABLE_ROW_COUNT) {
      this.params.size = this.rowSize
      setTimeout(() => {
        this.scrollToElement()
      }, 300)
    }
    this.updateData()
  },
  watch: {
    content: {
      deep: true,
      handler(val) {
        if (val) {
          this.tableContent = this.content
          this.isLoading = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
.list-move {
  transition: all 0.2s ease-in-out !important;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.2s !important;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(40px) !important;
}

.fruit-list-item {
  transition: all 0.3s !important;
  word-break: break-word;

  & > * {
    transition: all 0.3s !important;
    overflow: hidden !important;
  }
}

.uk-table {
  p {
    margin: 0;
  }

  .first-column {
    margin-bottom: 5px;
  }
}
</style>
